import { __rest, __read, __assign } from 'tslib';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { forwardRef, useState } from 'react';
import AnimateHeight from 'react-animate-height';
import '../hooks/useDetectInputMethod.js';
import { useId } from '@reach/auto-id';
import { useTheme } from '../hooks/useTheme.js';
import { Box } from '../Box/index.js';
import { TrProvider } from './TrProvider.js';
import { useTableContext } from './TableProvider.js';

var trStyle = {
    display: "grid",
    overflow: "hidden",
    gridTemplateRows: "1fr",
    gridTemplateColumns: "repeat(auto-fit, minmax(1%, 1fr))",
    "+[data-table-row-disclosure]": {
        display: "block",
        "[data-table-cell-disclosure]": {
            display: "block",
        },
        "[data-table-cell-disclosure-box]": {
            display: "block",
            overflow: "hidden",
        },
    },
};
var Tr = forwardRef(function Tr(_a, ref) {
    var _b;
    var id = _a.id, disclosure = _a.disclosure, disclosureRef = _a.disclosureRef, isOpen = _a.isOpen, selected = _a.selected, children = _a.children, _c = _a.themeKey, themeKey = _c === void 0 ? "tableRow" : _c, props = __rest(_a, ["id", "disclosure", "disclosureRef", "isOpen", "selected", "children", "themeKey"]);
    var columnsTemplate = useTableContext().state.columnsTemplate;
    var _d = useTheme(), handleStyleProps = _d.handleStyleProps, theme = _d.theme;
    var _e = __read(useState(false), 2), isHover = _e[0], setIsHover = _e[1];
    var _f = __read(useState(false), 2), isAnimating = _f[0], setIsAnimating = _f[1];
    var forwardProps = handleStyleProps(props, {
        themeKey: themeKey,
        baseStyle: __assign(__assign({}, trStyle), (columnsTemplate && { gridTemplateColumns: columnsTemplate })),
    });
    var handleOnMouseEnter = function () {
        !!disclosure && setIsHover(true);
    };
    var handleOnMouseLeave = function () {
        !!disclosure && setIsHover(false);
    };
    var autoId = useId();
    var rowId = id ? id : "table-row--".concat(autoId);
    var context = {
        state: { rowId: rowId, isOpen: isOpen },
    };
    var disclosureRow = !!disclosure && (jsx("tr", __assign({ ref: disclosureRef, "data-table-row-disclosure": true, "data-is-hover": isHover, onMouseEnter: handleOnMouseEnter, onMouseLeave: handleOnMouseLeave }, { children: jsx("td", __assign({ "data-table-cell-disclosure": true, colSpan: 99999 }, { children: jsx(AnimateHeight, __assign({ id: "".concat(rowId, "-disclosure"), duration: (theme === null || theme === void 0 ? void 0 : theme.duration) && ((_b = theme === null || theme === void 0 ? void 0 : theme.duration) === null || _b === void 0 ? void 0 : _b.length) > 1
                    ? parseInt(theme.duration[1])
                    : 250, height: isOpen ? "auto" : 0, onAnimationStart: function () {
                    setIsAnimating(true);
                }, onAnimationEnd: function () {
                    setIsAnimating(false);
                } }, { children: jsx(Box, __assign({ "data-table-cell-disclosure-box": true }, { children: disclosure })) })) })) })));
    return (jsxs(TrProvider, __assign({ value: context }, { children: [jsx("tr", __assign({ "data-table-row": true, "data-is-open": !!disclosure && isOpen, "data-selected": selected, ref: ref, onMouseEnter: handleOnMouseEnter, onMouseLeave: handleOnMouseLeave, "data-is-hover": isHover, "data-is-animating": isAnimating }, forwardProps, { children: children })), disclosureRow] })));
});

export { Tr };
//# sourceMappingURL=Tr.js.map
